import ItemView, {
  IComponentProps as IComponentBaseProps,
  IComponentState as IComponentBaseState,
} from './ItemView';
import { item_createNewQuill } from 'store/providers/providerSlice';
import { IProviderItemViewWithData } from '../../../../store/providers/providerTypes';
import i18n from '../../../../i18n';
import { blue } from '../../../../utils/style/colors';
import { IUsers } from '../../../../store/store';

interface IComponentProps extends IComponentBaseProps {
  listIndex?: number;
  onOpenFolder?: (index: number, id: number) => void;
  users?: IUsers;
}

interface IComponentState extends IComponentBaseState {
  activeLanguage: string;
}

class QuillView extends ItemView<IComponentProps, IComponentState> {
  constructor(props: IComponentProps) {
    super(props);
  }

  deleteItemTitle(name: string) {
    return i18n.t('deleteQuillTitle', {
      ns: 'documentManager',
      quillName: name,
    });
  }
  deleteItemMessage(name: string) {
    return i18n.t('deleteQuillMessage', {
      ns: 'documentManager',
      quillName: name,
    });
  }
  onOpenFunction(item: IProviderItemViewWithData, isNewTab: boolean) {
    return (e: any) => {
      this.props.onOpenItem(
        item,
        'view',
        undefined,
        isNewTab || e.altKey || e.metaKey
      );
    };
  }
  getThumbnail() {
    return ['document.svg', blue];
  }
  handelConfirmCreatingNewItem(item: IProviderItemViewWithData) {
    item.data.name = this.nameInput.value;
    item.data.order = this.props.expectedOrder;
    this.props.dispatch(item_createNewQuill({ item: item.data }));
  }
  newItemPlaceHolder() {
    return i18n.t('newQuillPlaceholder', { ns: 'documentManager' });
  }
  newItemTitle() {
    return i18n.t('newQuillTitle', { ns: 'documentManager' });
  }
  getMenuActions(itemId: number, editable: boolean) {
    return super.getMenuActions(itemId, editable);
  }
}

export default QuillView;
